import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import { CrntCheckableFormControlGroupMixin } from '../checkable-form-control-group/checkable-form-control-group.component.js';
import checkableFormControlGroupStyles from '../checkable-form-control-group/checkable-form-control-group.css.js';
import { CrntRadio } from '../radio/radio.component.js';
import radioGroupStyles from './radio-group.css.js';

const CrntCheckableFormControlGroup = CrntCheckableFormControlGroupMixin(CrntElement, {
  checkableFormControlSelector: CrntRadio.tagName,
  checkableFormControlSelectorBorderedSelector: `${CrntRadio.tagName}[bordered]`,
  linkSlottedFormElementsControllerOptions: {
    selectors: {
      help: `[slot="help"]:not(${CrntRadio.tagName} [slot="help"])`,
      input: ":not([slot]):is(input[type=radio])",
      validation: `[slot="validation"]:not(${CrntRadio.tagName} [slot="validation"])`
    }
  }
});
class CrntRadioGroup extends CrntCheckableFormControlGroup {
  static {
    this.styles = [trustedCSS(radioGroupStyles), trustedCSS(checkableFormControlGroupStyles)];
  }
  static {
    this.tagName = "crnt-radio-group";
  }
}

export { CrntRadioGroup };
